import AppWrapper, { AppWrapperProps } from './AppWrapper';

export type { AppWrapperProps };
export default AppWrapper;
